// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetSessionResponse

export type WidgetSessionApiResponse = {
	name: string;
	durationByPax: Record<string, number>;
	activityId: string;
};

export type WidgetSession = {
	name: string;
	durationByPax: Record<string, number>;
	activityId: string;
};

export function hydrateWidgetSession(data: WidgetSessionApiResponse): WidgetSession {
	return {
		...data,
		durationByPax: Array.isArray(data.durationByPax) ? {} : data.durationByPax,
	};
}